export const AddDebugData = "AddDebugData";
export const CommitDebug = "DebugData"

export function dispatchData(key: string, data: any): void
{
    window.dispatchEvent(new CustomEvent(AddDebugData, {
        detail: {
            key, data
        }
    }));
}

export function commitDebugData(): void
{
    window.dispatchEvent(new CustomEvent(CommitDebug))
}